// 🔑 الصلاحيات المخصّصة (RBAC) — 62 صلاحية موزّعة على 10 أقسام
// تُستخدم على User.customPermissions كمصفوفة JSON من المفاتيح
// الأدمن لديه كل الصلاحيات تلقائياً (bypass)

export interface PermissionGroup {
  key: string;
  label: string;
  labelEn: string;
  permissions: Permission[];
}

export interface Permission {
  key: string;
  label: string;
  labelEn: string;
}

export const PERMISSION_GROUPS: PermissionGroup[] = [
  {
    key: 'users',
    label: 'إدارة المستخدمين',
    labelEn: 'User Management',
    permissions: [
      { key: 'users.view',          label: 'عرض المستخدمين',         labelEn: 'View users' },
      { key: 'users.create',        label: 'إضافة مستخدم',           labelEn: 'Create user' },
      { key: 'users.edit',          label: 'تعديل المستخدمين',       labelEn: 'Edit users' },
      { key: 'users.delete',        label: 'حذف المستخدمين',         labelEn: 'Delete users' },
      { key: 'users.role',          label: 'تغيير الأدوار',          labelEn: 'Change roles' },
      { key: 'users.permissions',   label: 'منح/سحب صلاحيات',         labelEn: 'Manage permissions' },
      { key: 'users.verify',        label: 'توثيق المستخدمين',       labelEn: 'Verify users' },
      { key: 'users.suspend',       label: 'إيقاف/تفعيل حسابات',     labelEn: 'Suspend accounts' },
    ],
  },
  {
    key: 'properties',
    label: 'إدارة العقارات',
    labelEn: 'Properties',
    permissions: [
      { key: 'properties.view',     label: 'عرض العقارات',           labelEn: 'View properties' },
      { key: 'properties.create',   label: 'إضافة عقار',             labelEn: 'Create property' },
      { key: 'properties.edit',     label: 'تعديل العقارات',         labelEn: 'Edit properties' },
      { key: 'properties.delete',   label: 'حذف العقارات',           labelEn: 'Delete properties' },
      { key: 'properties.approve',  label: 'مراجعة وقبول العقارات',  labelEn: 'Approve properties' },
      { key: 'properties.feature',  label: 'تمييز العقارات',         labelEn: 'Feature properties' },
    ],
  },
  {
    key: 'auctions',
    label: 'إدارة المزادات',
    labelEn: 'Auctions',
    permissions: [
      { key: 'auctions.view',       label: 'عرض المزادات',           labelEn: 'View auctions' },
      { key: 'auctions.create',     label: 'جدولة مزاد',             labelEn: 'Create auction' },
      { key: 'auctions.edit',       label: 'تعديل المزادات',         labelEn: 'Edit auctions' },
      { key: 'auctions.delete',     label: 'حذف المزادات',           labelEn: 'Delete auctions' },
      { key: 'auctions.cancel',     label: 'إلغاء المزادات',         labelEn: 'Cancel auctions' },
      { key: 'auctioneer',          label: 'دور المحرّج (حراج 1/2/3/بيع)', labelEn: 'Auctioneer (going 1/2/3/sold)' },
      { key: 'auction.voice',       label: 'البث الصوتي للمزاد',     labelEn: 'Auction voice broadcast' },
      { key: 'auction.grant_mic',   label: 'منح/سحب المايك للحاضرين', labelEn: 'Grant/revoke mic' },
      { key: 'auction.moderate_chat', label: 'إدارة شات المزاد (mute/kick/ban)', labelEn: 'Moderate auction chat' },
      { key: 'auction.end',         label: 'إنهاء المزاد',           labelEn: 'End auction' },
      { key: 'auction.refund',      label: 'استرداد العربون',        labelEn: 'Refund deposits' },
    ],
  },
  {
    key: 'requests',
    label: 'طلبات العقارات',
    labelEn: 'Property Requests',
    permissions: [
      { key: 'requests.view',       label: 'عرض الطلبات',            labelEn: 'View requests' },
      { key: 'requests.assign',     label: 'إسناد الطلبات لمسوّق',   labelEn: 'Assign requests' },
      { key: 'requests.update',     label: 'تحديث حالة الطلب',       labelEn: 'Update request status' },
      { key: 'requests.match',      label: 'مطابقة طلب بعقار',       labelEn: 'Match request to property' },
      { key: 'requests.close',      label: 'إغلاق الطلبات',          labelEn: 'Close requests' },
      { key: 'requests.delete',     label: 'حذف الطلبات',            labelEn: 'Delete requests' },
    ],
  },
  {
    key: 'brokers',
    label: 'المسوّقون العقاريون',
    labelEn: 'Brokers',
    permissions: [
      { key: 'brokers.view',        label: 'عرض المسوّقين',          labelEn: 'View brokers' },
      { key: 'brokers.verify',      label: 'توثيق رخصة',             labelEn: 'Verify license' },
      { key: 'brokers.subscription', label: 'إدارة الاشتراكات',      labelEn: 'Manage subscriptions' },
      { key: 'brokers.complaints',  label: 'مراجعة الشكاوى',         labelEn: 'Review complaints' },
    ],
  },
  {
    key: 'wallet',
    label: 'المحفظة الإلكترونية',
    labelEn: 'Wallet',
    permissions: [
      { key: 'wallet.view',         label: 'عرض محافظ المستخدمين',   labelEn: 'View wallets' },
      { key: 'wallet.adjust',       label: 'تعديل الرصيد',           labelEn: 'Adjust balance' },
      { key: 'wallet.refund',       label: 'استرداد',                labelEn: 'Refund' },
      { key: 'wallet.trusted',      label: 'تعيين مزايد موثوق',      labelEn: 'Trusted bidder flag' },
    ],
  },
  {
    key: 'messages',
    label: 'رسائل التواصل',
    labelEn: 'Contact Messages',
    permissions: [
      { key: 'messages.view',       label: 'عرض الرسائل',            labelEn: 'View messages' },
      { key: 'messages.reply',      label: 'الرد على الرسائل',       labelEn: 'Reply to messages' },
      { key: 'messages.delete',     label: 'حذف الرسائل',            labelEn: 'Delete messages' },
    ],
  },
  {
    key: 'content',
    label: 'محتوى الموقع',
    labelEn: 'Site Content',
    permissions: [
      { key: 'content.services',    label: 'إدارة الخدمات',          labelEn: 'Manage services' },
      { key: 'content.faqs',        label: 'إدارة الأسئلة الشائعة',  labelEn: 'Manage FAQs' },
      { key: 'content.ads',         label: 'إدارة الإعلانات/البانرات', labelEn: 'Manage ads/banners' },
    ],
  },
  {
    key: 'unions',
    label: 'اتحادات الملاك',
    labelEn: 'Owners Unions',
    permissions: [
      { key: 'unions.view',         label: 'عرض الاتحادات',          labelEn: 'View unions' },
      { key: 'unions.manage',       label: 'إدارة اتحاد',            labelEn: 'Manage union' },
      { key: 'unions.facility',     label: 'إدارة طلبات الصيانة',    labelEn: 'Manage facility requests' },
    ],
  },
  {
    key: 'system',
    label: 'إعدادات النظام',
    labelEn: 'System Settings',
    permissions: [
      { key: 'system.settings',     label: 'إعدادات الموقع',         labelEn: 'Site settings' },
      { key: 'system.maintenance',  label: 'وضع الصيانة',            labelEn: 'Maintenance mode' },
      { key: 'system.audit',        label: 'سجل العمليات',           labelEn: 'Audit log' },
      { key: 'system.notifications', label: 'إدارة الإشعارات',       labelEn: 'Manage notifications' },
      { key: 'system.kpis',         label: 'مؤشرات الأداء',          labelEn: 'KPIs / Stats' },
      { key: 'system.export',       label: 'تصدير البيانات',         labelEn: 'Export data' },
    ],
  },
];

// مصفوفة مسطّحة لكل المفاتيح
export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap((g) => g.permissions.map((p) => p.key));

// إجمالي العدد
export const TOTAL_PERMISSIONS = ALL_PERMISSIONS.length;

// Helper: تحقق من صلاحية واحدة
export function hasPermission(
  role: string | undefined | null,
  customPermissions: string[] | undefined | null,
  key: string,
): boolean {
  // الأدمن والسوبر أدمن لديهم كل شيء
  if (role === 'ADMIN' || role === 'SUPER_ADMIN') return true;
  if (!customPermissions || !Array.isArray(customPermissions)) return false;
  return customPermissions.includes(key);
}
